import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { Box, Drawer, IconButton, SvgIcon } from '@mui/material';

import { ReactComponent as MenuIcon } from 'assets/icons/MenuIcon.svg';
import { ReactComponent as PlusIcon } from 'assets/icons/PlusIcon.svg';

import { Button } from 'components/_basic/Button/Button';
import { CloseButton } from 'components/_basic/CloseButton/CloseButton';
import { AccountSettingsMobile } from 'components/AccountSettings/AccountSettingsMobile';

import { useBooleanState } from 'helpers/useBooleanState';

import { useHeaderLogic } from './HeaderLogicProvider';

import styles from './MobileBurgerMenu.module.scss';

export const MobileBurgerMenu: FC = () => {
  const [isMenuOpened, openMenu, closeMenu] = useBooleanState(false);
  const location = useLocation();
  const { t } = useTranslation();
  const isSubscriptionPage2 = location.pathname === '/subscription-plans-2';

  const {
    isUserAuth,
    isUpgradeButtonVisible,
    handleWorkspaceClick,
    handleClickCreateProject,
    handleClickUpgradePlan,
    handleSignInModalOpen,
    handleSignUpModalOpen,
  } = useHeaderLogic();

  const handlehandleSignInClick = () => {
    localStorage.removeItem('freePlanClicked');
    localStorage.removeItem('choosedSubscription');
    handleSignInModalOpen();
    closeMenu();
  };
  const handlehandleSignUpClick = () => {
    localStorage.removeItem('freePlanClicked');
    localStorage.removeItem('choosedSubscription');
    handleSignUpModalOpen();
    closeMenu();
  };

  return (
    <>
      <IconButton className={styles['burger_menu_button']} onClick={openMenu} size="medium">
        <SvgIcon component={MenuIcon} inheritViewBox />
      </IconButton>
      <Drawer open={isMenuOpened} onClose={closeMenu} anchor="right" sx={{ '.MuiPaper-root': { minWidth: 252 } }}>
        <CloseButton className={styles['close_button']} onClick={closeMenu} />
        <Box className={styles['drawer_content']}>
          {!isUserAuth ? (
            <Box className={styles['sigh_wrapper']}>
              <Button onClick={handlehandleSignUpClick} variant="contained" fullWidth>
                {t('signUpBig')}
              </Button>
              <Button onClick={handlehandleSignInClick} variant="text" color="info" fullWidth>
                {t('logInBig')}
              </Button>
            </Box>
          ) : (
            <Box className={styles['account_settings_wrapper']}>
              <Button
                onClick={() => {
                  handleWorkspaceClick();
                  closeMenu();
                }}
                className={styles['workspace_button']}
                variant="text"
                color="info"
                size="large"
                fullWidth
              >
                {t('workspace')}
              </Button>
              <AccountSettingsMobile onClose={closeMenu} />
            </Box>
          )}
          <Box className={styles['project_buttons_wrapper']}>
            {isUpgradeButtonVisible && (
              <Button
                onClick={() => {
                  handleClickUpgradePlan();
                  closeMenu();
                }}
                variant="outlined"
                color="secondary"
                fullWidth
              >
                {t('upgradePlan')}
              </Button>
            )}
            {isUserAuth && (!isSubscriptionPage2 || !localStorage.getItem('onlyPayedSignUp')) && (
              <Button
                onClick={() => {
                  handleClickCreateProject();
                  closeMenu();
                }}
                variant="outlined"
                fullWidth
                endIcon={<PlusIcon style={{ fill: 'inherit' }} />}
              >
                {t('createProject')}
              </Button>
            )}
          </Box>
        </Box>
      </Drawer>
    </>
  );
};
